import type { TextFontWeightModifierValue } from "schemas/generated/fileModifiers";

import React from "react";

import FontWeightSelector from "@v2/features/modifiers/base/FontWeightSelector";
import { useOptimisticModifierValue } from "@v2/features/modifiers/hooks/useOptimisticModifierValue";
import { useDefaultSelectedElementDesignation } from "@v2/features/modifiers/store/ModifiersStoreContext";

interface FontWeightModifierProps {
  onChange: (modifiers: TextFontWeightModifierValue[]) => void;
}

const FontWeightModifierComponent: React.FC<FontWeightModifierProps> = ({
  onChange,
}) => {
  const defaultDesignation = useDefaultSelectedElementDesignation();

  const currentValue =
    useOptimisticModifierValue({
      modifierType: { type: "fontWeight", value: 400 },
      extractor: (elementDesignation) => {
        return elementDesignation.element.styleOverrides?.fontWeight ?? null;
      },
    }) ?? null;

  const fontFamily =
    defaultDesignation?.element.styleOverrides?.fontFamily ?? null;

  const handleValueChange = (weight: number | null) => {
    if (weight) {
      onChange([
        {
          type: "fontWeight" as const,
          value: weight,
        },
      ]);
    }
  };

  return (
    <div className="font-weight-modifier">
      <FontWeightSelector
        fontWeight={currentValue}
        onSelect={handleValueChange}
        placeholder="Select weight"
        fontFamily={fontFamily}
      />
    </div>
  );
};

export default FontWeightModifierComponent;
